<script setup lang="ts">
const { t } = useI18n()
const config = useRuntimeConfig()
const shopName = config.public.shopName

useHead({
    title: t('newsletter.metaTitle', { shopName: shopName })
})
</script>

<template>
    <div class="mx-auto w-full max-w-8xl px-2 py-8">
        <div class="max-w-4xl mx-auto">
            <fieldset>
                <FormsNewsletter />
            </fieldset>
        </div>
    </div>
</template>